import { VERSION } from '@core/release'
import {
  aplicarTema,
  lerPreferencia,
  resolverTema,
  sistemaPrefereClaro,
} from '@core/tema'
import { decidirERegistar } from '@core/layout/ribbon/ribbonMoves'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installFirebimHandoffCapture } from '@core/firebimHandoff'
import { initRecovery } from '@core/session/recovery'

// Handoff do VN2R-FireBIM: instalado ANTES do render (e do gate de auth) para
// apanhar o payload mesmo que a aba comece na pagina de login. Grava em
// IndexedDB; o viewer drena-o quando montar. Ver core/firebimHandoff.ts.
installFirebimHandoffCapture()

// Rede de recuperação: decidida ANTES do primeiro render para nenhuma
// leitura de trabalho (BCFs, viewpoints, vistas 2D, rascunhos) passar
// antes de o utilizador dizer se quer recuperar a sessão anterior.
initRecovery()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// O tema escreve-se ANTES do primeiro render. Fazê-lo num efeito
// deixava a aplicação pintar-se escura e mudar para clara à frente de
// quem está a olhar.
aplicarTema(resolverTema(lerPreferencia(), sistemaPrefereClaro()))

// Decide, uma vez e antes de tudo, se a nota "o que mudou de sítio" se
// mostra neste browser, e regista a versão vista. Aqui e não dentro da
// nota, porque no telemóvel o friso (e a nota) não chegam a ser
// montados e a versão tem de ficar registada na mesma.
decidirERegistar(VERSION)

// PWA: registo do service worker (public/sw.js) só em produção; em dev
// interferia com o HMR do Vite. Falha em silêncio (browsers sem SW ou
// contexto não-seguro ficam como estavam).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
